import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useCallback } from 'react';
import { sanitizeUrlString } from '@atlassian/commerce-privacy/url';
import { HttpResponseError } from '@atlassian/commerce-service-hook';
import { useSentryExceptionDispatch } from '@atlassian/commerce-telemetry/dispatch-hooks';
import { useCommerceOverride } from '../use-commerce-override';
export var useCommerceFetch = function useCommerceFetch() {
  var commerceContextFetch = useCommerceOverride(fetch);
  var dispatchSentryException = useSentryExceptionDispatch();
  return useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _len,
        args,
        _key,
        fetchInput,
        sanitizedUrl,
        response,
        oldErrorMessage,
        newErrorMessage,
        wrappedError,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }

            fetchInput = args[0];
            sanitizedUrl = sanitizeUrlString(typeof fetchInput === 'string' ? fetchInput : fetchInput.url);
            _context.prev = 3;
            _context.next = 6;
            return commerceContextFetch.apply(void 0, args);

          case 6:
            response = _context.sent;

            if (response.status >= 400) {
              dispatchSentryException({
                exception: new Error("Status: ".concat(response.status, "\nURL: ").concat(sanitizedUrl))
              });
            }

            return _context.abrupt("return", response);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            // eslint-disable-next-line no-console
            console.warn(_context.t0);

            oldErrorMessage = function () {
              if (_context.t0 instanceof Error) {
                var _error$stack;

                return (_error$stack = _context.t0.stack) !== null && _error$stack !== void 0 ? _error$stack : _context.t0.toString();
              } else {
                return JSON.stringify(_context.t0);
              }
            }();

            newErrorMessage = "An error occurred when fetching from ".concat(sanitizedUrl, "\n\n ").concat(oldErrorMessage);
            wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
              exception: wrappedError
            });
            throw _context.t0;

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 11]]);
  })), [commerceContextFetch, dispatchSentryException]);
};
export var reportHttpError = function reportHttpError(request, dispatchSentryException) {
  return request.catch(function (error) {
    // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
    if (error instanceof HttpResponseError) {
      dispatchSentryException({
        exception: error
      });
    }

    var oldErrorMessage = function () {
      if (error instanceof Error) {
        var _error$stack2;

        return (_error$stack2 = error.stack) !== null && _error$stack2 !== void 0 ? _error$stack2 : error.toString();
      } else {
        return JSON.stringify(error);
      }
    }();

    var newErrorMessage = "An error occurred when fetching data\n\n ".concat(oldErrorMessage);
    dispatchSentryException({
      exception: new Error(newErrorMessage)
    });
    return error;
  });
};